import { render, staticRenderFns } from "./Finance.vue?vue&type=template&id=0988e316&scoped=true&"
import script from "./Finance.vue?vue&type=script&lang=js&"
export * from "./Finance.vue?vue&type=script&lang=js&"
import style0 from "./Finance.vue?vue&type=style&index=0&id=0988e316&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988e316",
  null
  
)

export default component.exports